<template>
  <div class="company-info" v-if="renderArray">
    <h1 class="names">{{ renderArray.orgName }}</h1>

    <el-carousel
      arrow="never"
      :autoplay="false"
      trigger="click"
      v-if="data&&data.length>0"
      :height="'320px'"
      style=" margin-top: 10px;"
    >
      <el-carousel-item v-for="item in data" :key="item.deviceId">
        <video-player :options="item.playerOptions" v-if="show"></video-player>
       <div v-else>
          <iframe
            id="show-iframe"
            :src="'http://videoflow.cloud.zhenyuanma.com/?deviceCode='+item.deviceId+(item.channelNo?item.channelNo:'')+'&height=290'"
            width="100%"
			height="290px"
			allowfullscreen="true"
          ></iframe>
        </div>
      </el-carousel-item>
      <!-- 按钮区域 -->
    </el-carousel>
    <p>企业名称: {{ renderArray.orgName }}</p>
    <p>联系方式: {{ renderArray.managerPhone }}</p>
    <p v-if="renderArray.registeredCapital && renderArray.registeredCapital != '' ">注册资本: {{ renderArray.registeredCapital }}万人民币</p>
    <p>主营产品: {{ renderArray.businessScope }}</p>
  </div>
</template>

<script>
import {pushStream,getMonitorInfo} from "../../api/video.js";
import {getCommpany} from "../../api/region.js";
//引入直播流的videoPlayer依赖
import "video.js/dist/video-js.css";
import { videoPlayer } from "vue-video-player";
import {mapGetters,mapMutations} from "vuex";
export default {
  data() {
    return {
      show: true,
      data: [],
	  renderArray:'',
    };
  },
  watch: {
    // $route(to, from) {
    //   if (/\/company/gi.test(to.path)) {
    //     this.getShow();
    //     this.data = [];
    //     this.getLists(this.orgIdNum);
    //   }
    // },
	
	async orgIdNum(val)
	{
		if(val != 0)
		{
			this.getLists(val);
			this.getData(val);
		}
	}
  },
  mounted() {
    this.getShow();
    this.getLists(this.orgIdNum);
	this.getData(this.orgIdNum)
  },
  methods: {
	...mapMutations(['saveVideoData']),
	getData(id) {
	  //要返回出去的请求回来的对象
	  let renderObj = null;
	    getCommpany(id)
	    .then(res => {
	      this.renderArray = res.data;
	    })
	    .catch(err => {
	      console.log(err);
	    });
	},  
    getShow() {
      var userAgent = navigator.userAgent;
      var isOpera = userAgent.indexOf("Opera") > -1;
      let client = {
        weixin: /micromessenger/gi.test(navigator.userAgent),
        app: /cnhnb/gi.test(navigator.userAgent),
        ios:
          /cnhnb/gi.test(navigator.userAgent) &&
          /ios/gi.test(navigator.userAgent),
        android:
          /cnhnb/gi.test(navigator.userAgent) &&
          /android/gi.test(navigator.userAgent),
        pc: /windows/gi.test(navigator.userAgent)
      };
      if (client.pc) {
        this.show = false;
      } else {
        this.show = true;
      }
    },
    getStream(deviceId) {
      let data = {
        deviceId: deviceId
      };
      pushStream(data).then(res => {
        if (res.code == 0 && res.data == true) {
          console.log("推流成功");
          let vue = this;
          window.setTimeout(function() {
            vue.getStream(deviceId);
          }, 15000);
        }
      }); 
    },
    getLists(orgId) {
	  this.data = [];
      getMonitorInfo(orgId)
        .then(res => {
			console.log("getLists",res)
			let {suyuanVideoDataNodes} = res.data;
			this.saveVideoData(suyuanVideoDataNodes)
          if (suyuanVideoDataNodes) {
            suyuanVideoDataNodes.forEach(o => {
              this.data.push(o);
            });
            this.data.forEach(o => {
              this.getStream(o.deviceId);
              o.playerOptions = {
                playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
                autoplay: true, //如果true,浏览器准备好时开始回放。
                controls: true, //控制条
                preload: "auto", //视频预加载
                muted: false, //默认情况下将会消除任何音频。
                loop: false, //导致视频一结束就重新开始。
                language: "zh-CN",
                aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                sources: [
                  {
                    headers: {
                      "Access-Control-Alow-Orogin": "*"
                    },
                    type: "application/x-mpegURL",
                    src: o.videoResource
                  }
                ],
                width: document.documentElement.clientWidth,
                notSupportedMessage: "此视频暂无法播放，请稍后再试" //允许覆盖Video.js无法播放媒体源时显示的默认信息。
              };
            });
          }
        })
        .catch(err => {});
    }
  },
  computed:{
	  ...mapGetters(['orgIdNum'])
  }
};
</script>

<style lang='less'>
.names{
	padding-bottom: 20px;
}	
</style>